import { useMemo } from 'react';
import arrowDown from '~/assets/icons/arrow_down.svg';
import arrowLeft from '~/assets/icons/arrow_left.svg';
import arrowRight from '~/assets/icons/arrow_right.svg';
import arrowUp from '~/assets/icons/arrow_up.svg';
import { TabButton } from '../TabButton';
import { StyledContainer, StyledIconContainer } from './HelpButton.styled';

interface IHelpButtonProps {
	button: string;
	icon: string;
	isHelp: boolean;
	isReport: boolean;
}

const HelpButton: React.FC<IHelpButtonProps> = ({
	button,
	icon,
	isHelp,
	isReport,
}: IHelpButtonProps) => {
	const buttonIcon = useMemo(() => {
		switch (button) {
			case 'ArrowLeft':
				return arrowLeft;
			case 'ArrowRight':
				return arrowRight;
			case 'ArrowUp':
				return arrowUp;
			case 'ArrowDown':
				return arrowDown;
			default:
				return null;
		}
	}, [button]);

	return (
		<StyledContainer>
			<TabButton $fixed={!!buttonIcon}>
				{buttonIcon ? <img src={buttonIcon} width={12} height={12} /> : button}
			</TabButton>
			<StyledIconContainer $isHelp={isHelp} $isReport={isReport}>
				<img src={icon} width={16} height={16} />
			</StyledIconContainer>
		</StyledContainer>
	);
};

export { HelpButton };
